import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';

const FaChevronRightComponent =
  FaChevronRight as unknown as React.ComponentType<{
    size?: number | string;
    className?: string;
  }>;

const QuickActions: React.FC = () => {
  const navigate = useNavigate();

  // Defines quick action buttons for common tasks
  const actions = [
    { label: 'Create Campaign', path: '/campaigns/create' },
    { label: 'Set up Automation', path: '/automations/create' },
    { label: 'Create Template', path: '/templates/create' },
  ];

  const handleActionClick = (path: string) => {
    navigate(path);
  };

  // Renders a list of quick action buttons
  // Displays clickable buttons for creating campaigns, automations, and templates
  return (
    <div className='bg-white p-4 rounded-lg shadow-sm border mb-6'>
      <h3
        className='text-lg font-semibold mb-4'
        style={{
          color: '#0D121A',
          fontSize: '20px',
        }}
      >
        Quick Actions
      </h3>
      <div className='space-y-3'>
        {actions.map((action, idx) => (
          <button
            key={idx}
            onClick={() => handleActionClick(action.path)}
            className='w-full flex items-center justify-between px-4 py-3 bg-gray-100 rounded-lg hover:bg-gray-200 transition'
          >
            <span className='text-gray-700 font-medium text-sm'>
              {action.label}
            </span>
            <FaChevronRightComponent size={14} className='text-gray-500' />
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;